import React from "react";
import { Modal, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Document, Page } from "react-pdf";

interface PdfPreviewModalProps {
  open: boolean;
  onClose: () => void;
  fileUrl: string;
}

const PdfPreviewModal: React.FC<PdfPreviewModalProps> = ({
  open,
  onClose,
  fileUrl,
}) => {
  const [numPages, setNumPages] = React.useState<number>(0);
  const [pdfWidth, setPdfWidth] = React.useState<number>(600); // Default width

  const onDocumentLoadSuccess = React.useCallback(
    ({ numPages }: { numPages: number }) => {
      setNumPages(numPages);
    },
    []
  );

  const onPageLoadSuccess = (page: any) => {
    const viewport = page.getViewport({ scale: 1 });
    setPdfWidth(Math.min(viewport.width, 900)); // cap max width
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: pdfWidth + 40, // dynamic width based on PDF size
          maxWidth: "95vw",
          height: "90vh",
          bgcolor: "black",
          boxShadow: 24,
          borderRadius: "10px",
          overflow: "hidden",
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            zIndex: 10,
            background: "#ccc",
            color: "gray",
            "&:hover": { background: "gray" },
          }}
        >
          <CloseIcon style={{ color: "black" }} />
        </IconButton>

        {/* PDF VIEWER */}
        <Box
          sx={{
            height: "100%",
            overflowY: "auto",
            padding: "10px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Document file={fileUrl} onLoadSuccess={onDocumentLoadSuccess}>
            {Array.from({ length: numPages }, (_, index) => (
              <Page
                key={index}
                pageNumber={index + 1}
                width={pdfWidth}
                onLoadSuccess={onPageLoadSuccess}
                renderTextLayer={false}
                renderAnnotationLayer={false}
              />
            ))}
          </Document>
        </Box>
      </Box>
    </Modal>
  );
};

export default PdfPreviewModal;
